import { getAllPersons } from '@hr/actions/persons/personsgetall'
import { personPatch } from '@hr/api'
import { contextMenu, restoreViewState } from '@/common/grid.js'
import { pencilIconString, restoreIconString, TemplateProfileImage } from '@/common/icons.jsx'
import { eSalaryImage } from '@/common/utils.jsx'

const FILTERED_COLUMN = 'personStatus'

export const createPersonnelListGridProps = (dispatch) => ({
	animateRows: true,
	suppressCellFocus: true,
	enableCellTextSelection: true,
	singleClickEdit: true,
	onCellValueChanged: async (params) => {
		if (params.colDef.field !== 'personStatus' || params.source !== 'edit' || params.oldValue === params.newValue)
			return
		try {
			const currentPerson = params.data
			const person = {
				personId: currentPerson.personId,
				nr: currentPerson.nr,
				employmentDetails: { personStatus: params.newValue },
			}
			await personPatch(person.nr, person) // Patch person with new status
			dispatch(getAllPersons()) // Refetch the list
		} catch (err) {
			console.error('Error updating person status', err)
			params.node.setDataValue(params.column, params.oldValue)
		}
	},
	getMainMenuItems: (params) => params.defaultItems.slice(0, -1),
})

export const employeesViewStateKey = 'employeesViewState'
export const externalViewStateKey = 'externalWorkforceViewState'

export function applyEmployeesFilter(api, includeEnded) {
	if (includeEnded) {
		api.setFilterModel({})
		return
	}

	api.setFilterModel({
		[FILTERED_COLUMN]: {
			filterType: 'text',
			type: 'notEqual',
			filter: 'ENDED',
		},
	})
}

export function applyExternalFilter(api, includeEnded) {
	if (includeEnded) {
		api.setFilterModel({})
		return
	}

	api.setFilterModel({
		[FILTERED_COLUMN]: {
			filterType: 'text',
			type: 'notEqual',
			filter: 'ENDED_EXTERNAL',
		},
	})
}

export function getGridComponents(eSalaryCompanyId) {
	return {
		profileImage: ({ value }) => (
			<div className="profile-image">
				{value?.length ? (
					<img className="ag-image" alt="Profile" src={eSalaryImage(eSalaryCompanyId, value)} crossOrigin="anonymous" />
				) : (
					<TemplateProfileImage />
				)}
			</div>
		),
	}
}

export function getEmployeesContextMenuItems({ t, params, setReport, modifyPerson, companyName }) {
	let items = []
	items.push({
		name: t('DefaultGridValues', 'Palauta taulukon oletusasetukset'),
		action: () => {
			restoreViewState(employeesViewStateKey, {})
		},
		icon: restoreIconString,
	})

	items.push('separator')

	if (!params.api.isPivotMode()) {
		items.push({
			name: t('Edit', 'Muokkaa'),
			action: () => {
				modifyPerson(params.node.id)
			},
			icon: pencilIconString,
		})
		items.push('separator')
	}

	items = items.concat(
		contextMenu(t, params, setReport, {
			title: t('Persons', 'Henkilöt'),
			companyname: companyName,
		}),
	)

	return items
}

export function getExternalContextMenuItems({ t, params, setReport, modifyPerson, companyName }) {
	let items = []
	items.push({
		name: t('DefaultGridValues', 'Palauta taulukon oletusasetukset'),
		action: () => {
			restoreViewState(externalViewStateKey, {})
		},
		icon: restoreIconString,
	})

	items.push('separator')

	if (!params.api.isPivotMode()) {
		items.push({
			name: t('Edit', 'Muokkaa'),
			action: () => {
				modifyPerson(params.node.id)
			},
			icon: pencilIconString,
		})
		items.push('separator')
	}

	items = items.concat(
		contextMenu(t, params, setReport, {
			title: t('ExternalParties', 'Ulkopuoliset toimijat'),
			companyname: companyName,
		}),
	)

	return items
}
